import { render, staticRenderFns } from "./MentionsSettings.vue?vue&type=template&id=6d19314f&scoped=true"
import script from "./MentionsSettings.vue?vue&type=script&lang=js"
export * from "./MentionsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d19314f",
  null
  
)

export default component.exports